<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="title pt-5 pb-0">
        Pagamento Recusado
      </v-card-title>

      <v-card-text class="pt-2 pb-9">
        <p class="mb-0">
          Não conseguimos processar o pagamento desta vez.
          <br><br>
          <strong>Motivo:</strong> {{ motivo }}
          <br><br>
          Para garantir que sua assinatura continue ativa, tente utilizar outra forma de pagamento.
        </p>
      </v-card-text>

      <v-card-actions class="pt-9 flex-column flex-sm-row">
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="btn_fechar_recusa"
          @click="dialog = false"
        >
          Fechar
        </v-btn>

        <v-btn
          v-if="permitePix"
          color="primary"
          text
          data-cy="btn_pagar_pix_recusa"
          @click="pagarViaPix"
        >
          Pagar via PIX
        </v-btn>

        <v-btn
          color="primary"
          text
          data-cy="btn_tentar_outro_cartao"
          @click="tentarNovamente"
        >
          Tentar com outro Cartão
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ModalPagamentoRecusado',
  props: {
    value: Boolean,
    motivo: {
      type: String,
      default: '',
    },
    compraId: {
      type: Number,
      default: null,
    },
    permitePix: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('meuperfil', ['setAssinaturaCadastrarCartao', 'setRecobrarAposCadastro']),

    tentarNovamente() {
      this.setAssinaturaCadastrarCartao(true);
      // Intenção (não armada): só vira recobrança de fato após o cadastro do cartão ser salvo.
      this.setRecobrarAposCadastro(this.compraId);
      this.$router.push('/meu-perfil/cartoes-credito/cadastrar');
      this.dialog = false;
    },

    pagarViaPix() {
      this.$emit('pagar-pix', this.compraId);
      this.dialog = false;
    },
  },
};
</script>
